module.exports = __webpack_public_path__ + "static/JetBrainsMono-Bold-Italic-111bcb2a39ae6140cb21daa3ecd052d1.ttf";